/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useRef, useContext } from 'react';
import Head from 'next/head';
import Image from 'next/image';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import classNames from 'classnames';
import Select from 'react-select';
import { useTranslation } from 'next-i18next';
import { trim } from 'lodash';
import dayjs from 'dayjs';
import {
  Button,
  PC,
  useQuery,
  REPORT_PV_RETAINED_CAPITAL,
  REPORT_UV_RETAINED_CAPITAL,
  REPORT_CLI_IPT_BTN_SUCTION_BOTTOM,
  REPORT_LOAD_TIME,
  REPORT_CLI_IPT_BTN_GET,
  REPORT_CLI_IPT_PHONE,
  REPORT_CLI_IPT_MAIL,
  REPORT_FERM_WRONGFORM,
  apis,
  Toast,
  Loading as LoadingModal,
  Mobile,
  PHONE_REG,
  EMAIL_REG,
  FormItem,
  Input,
  PhoneInput as PhoneInputMobile,
} from '@wukong/haomao';
import RCForm from 'rc-field-form';
import withGTM from '../../../HOC/withGTM';
import useGTM from '../../../utils/hooks/useGTM';
import { generateNamePrefix, getChannelName, messageIsRepeat } from '../../../utils/helpers';
import { GTM_CHINESEFORM_ARGUS, REPORT_PAGE_NAME_CHINESE_MATH_CLASS } from '../../../utils/constants';
import { report } from '../../../utils/buryingPoint';
import { MyContext } from '../../../config/context-manager';
import Chinese from '../../../pageComponents/Chinese-math-class/Chinese/index';
import Math from '../../../pageComponents/Chinese-math-class/Math/index';
import Nav from '../../../pageComponents/Nav';
// import Banner from '../../../pageComponents/Chinese-math-class/Banner';
import PhoneInput from '../../../pageComponents/Chinese-math-class/Banner/PhoneInput';
import Multilingual from '../../../pageComponents/LandingResult/Multilingual/index';
import sloganImg from '../../../../public/images/logo-red.svg';
import monkeyImg from '../../../../public/images/chinese-math-class/ip.png';
import bannerContentLImg from '../../../../public/images/chinese-math-class/banner-content-l.png';
import bannerContentRImg from '../../../../public/images/chinese-math-class/banner-content-r.png';
import bannerContentLEnImg from '../../../../public/images/chinese-math-class/banner-content-l-en.png';
import bannerContentREnImg from '../../../../public/images/chinese-math-class/banner-content-r-en.png';
import bannerContentMEnImg from '../../../../public/images/chinese-math-class/banner-content-m-en.png';
import bannerContentMImg from '../../../../public/images/chinese-math-class/banner-content-m.png';
import { CountryResponse } from '../../../request/interface/common';
import useIsMobile from '../../../hooks/useIsMobile';
import styles from './style.module.scss';
import loadTime from '../../../hooks/loadTime';

const serviceLanguageOptions = [
  { value: '中文', label: 'Chinese' },
  { value: '英语', label: 'English' },
];
const pageName = REPORT_PAGE_NAME_CHINESE_MATH_CLASS;
const scrollToTop = () => {
  const sTop = document.documentElement.scrollTop || document.body.scrollTop;
  if (sTop > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, sTop - sTop / 4);
  }
};

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'chineseSpecialty',
        'mathSpecialty',
        'chineseMathClass',
        'landingResult',
      ])),
    },
  };
};

const ChineseMathClass = () => {
  const isMobile = useIsMobile();
  const [form] = RCForm.useForm();
  const { locale } = useContext(MyContext);
  const bannerRef = useRef<HTMLDivElement>(null);
  const sendDataToGTM = useGTM('CF_CM_');
  const { l = '', code = '', recommendStudentSId = '' } = useQuery() as Record<string, string>;
  const prefixMath = l?.substring(l.length - 4);
  const prefixName = generateNamePrefix(`${prefixMath}_`);
  const { t } = useTranslation('chineseMathClass');
  const [time] = loadTime();

  const [currentKey, setCurrentKey] = useState('chinese');
  const [hideBtn, setHideBtn] = useState(true);
  const [countryData, setCountryData] = useState<CountryResponse>({});
  const [countryCode, setCountryCode] = useState();
  const [serveLanguage, setServeLanguage] = useState<string | undefined>(locale === 'en' ? '英语' : '中文');
  const [successVisible, setSuccessVisible] = useState(false);
  const [WXCodeUrl, setWXCodeUrl] = useState('');
  // 中文重复进线
  const chineseRepeatRef = useRef(false);
  const mathRepeatRef = useRef(false);

  const reportParams = {
    l,
    subject: 'CHINESE',
    landingPageVersion: pageName,
    pv: null,
    uv: null,
  };

  const handleToTop = () => {
    scrollToTop();
    report(`${pageName}_${REPORT_CLI_IPT_BTN_SUCTION_BOTTOM}_${l}`, {
      ...reportParams,
      event: REPORT_CLI_IPT_BTN_SUCTION_BOTTOM,
    });
  };

  const handleItemClick = (key: string) => setCurrentKey(key);

  useEffect(() => {
    const bannerHeight = bannerRef.current?.clientHeight;
    const handleScroll = () => {
      const sTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      setHideBtn(sTop < (bannerHeight || 700));
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    report(
      `${pageName}_${REPORT_PV_RETAINED_CAPITAL}_${l}`,
      {
        ...reportParams,
        event: REPORT_PV_RETAINED_CAPITAL,
        pv: 1,
        originalUrl: window.location.href,
      },
      true,
    );

    report(`${pageName}_${REPORT_UV_RETAINED_CAPITAL}_${l}`, {
      ...reportParams,
      event: REPORT_UV_RETAINED_CAPITAL,
      uv: 1,
    });
    sendDataToGTM(prefixName`into_mathonline_success`);
  }, []);

  const [btnDisabled, setBtnDisabled] = useState(false);
  // const [prefix, setPrefix] = useState('');

  const formClickStatusRef = useRef({
    phone: false,
    mail: false,
  });

  useEffect(() => {
    apis.getCountry().then((res) => {
      // onTimezoneChange(res.data);
      setCountryData(res?.data);
      setCountryCode(res?.data?.countryList);
      form.setFieldsValue({
        phone: [res.data.countryCode, form.getFieldValue('phone')?.[1] || '', res.data.country || ''],
      });
    });
    if (l) {
      apis.getJsonNode(l).then((res) => {
        const ChannelName = getChannelName(res?.content?.nodeContent?.channel1 as string);
        // setPrefix(ChannelName);
        // PV
        sendDataToGTM(`${ChannelName}_PV_入口页`);
      });
    } else {
      sendDataToGTM(prefixName`PV_入口页`);
    }
  }, []);

  useEffect(() => {
    // 上报加载时间
    if (time && Object.keys(time).length !== 0) {
      report(
        `${pageName}_${REPORT_LOAD_TIME}_${l}`,
        {
          ...reportParams,
          event: REPORT_LOAD_TIME,
          loadTime: time,
          uv: null,
        },
        true,
      );
    }
  }, [time]);

  const createMath = (params: any) => {
    setBtnDisabled(false);
    LoadingModal.hide();
    // 判断中文和数学  是否都是老线索 都是老线索 不跳转
    if (!chineseRepeatRef.current) {
      setSuccessVisible(true);
    } else {
      Toast.info(t('表单-登记信息已存在'));
    }
    // 什么情况才触发表单 登记信息已存 报错 数学和中文 都进线失败的情况 current都为true的情况
    if (chineseRepeatRef.current) {
      report(
        `${pageName}_${REPORT_FERM_WRONGFORM}_${l}`,
        {
          ...reportParams,
          event: REPORT_FERM_WRONGFORM,
          leadFail: {
            message: t('表单-登记信息已存在'),
            mobile: params?.mobile,
            email: params?.mail,
          },
        },
        true,
      );
    }
  };

  const handleFinish = (value: { phone: Array<string>; mail: string }) => {
    mathRepeatRef.current = false;
    chineseRepeatRef.current = false;
    setBtnDisabled(true);
    LoadingModal.show('Loading...');
    sendDataToGTM(prefixName`CLK_BTN@立即获取`);
    report(`${pageName}_${REPORT_CLI_IPT_BTN_GET}_${l}`, {
      ...reportParams,
      event: REPORT_CLI_IPT_BTN_GET,
    });
    const params = {
      timezone: countryData?.timeZone?.itemValue,
      timezoneText: countryData?.timeZone?.itemName,
      country: value.phone?.[2],
      countryCode: value.phone?.[0],
      lead: l || '',
      formId: '',
      createFrom: 'h5',
      leadSource: 'h5',
      mobile: value.phone?.[1],
      email: value.mail,
      userId: '',
      time: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      code: code || '',
      recommendStudentSId: recommendStudentSId || '',
      leadType: 'Chinese',
      serveLanguage,
    };
    // 进线进两条 中文和数学
    // 调用 中文进线  徐展示后端错误提醒 ，屏蔽重复进线的提醒
    // 中文进线 成功后  ——》数学进线
    // 中文进线 不成功 422提醒重复进线 ——》数学进线
    // 中文、数学 都是重复进线 才提进入结果页
    apis
      .createLeadNoRemind(params)
      .then((res: any) => {
        if (res?.success) {
          // 判断是否重复进线
          if (res?.repetitionLead) {
            chineseRepeatRef.current = true;
          }
          sendDataToGTM(prefixName`PV_完成页`);
          const mathParams = {
            ...params,
            leadType: 'Math',
          };
          createMath(mathParams);
        }
        setWXCodeUrl(res?.data?.qrCode || '');
      })
      .catch((err) => {
        const { response } = err;
        const { data = {} } = response;
        const { errors, message } = data;
        const errMsg = (errors && errors[Object.keys(errors)[0]]) || message || err.message;
        if (messageIsRepeat(errMsg)) {
          chineseRepeatRef.current = true;
          const mathParams = {
            ...params,
            leadType: 'Math',
          };
          createMath(mathParams);
        } else {
          Toast.info(errMsg);
          setBtnDisabled(false);
          LoadingModal.hide();
          report(
            `${pageName}_${REPORT_FERM_WRONGFORM}_${l}`,
            {
              ...reportParams,
              event: REPORT_FERM_WRONGFORM,
              leadFail: {
                message: errMsg,
                mobile: JSON.stringify(value.phone),
                email: value.mail,
              },
            },
            true,
          );
        }
      });
  };

  const inputOnBlur = (e: any, inputName: string) => {
    // 去除输入框前后空格 并且页面input也不能有空格 ； 获取数据 更改数据
    const target = e?.target?.value;
    const data = trim(target);
    form.setFieldsValue({
      [inputName]: data,
    });
    form.validateFields([inputName]);
  };

  // 需求：点击各个输入框，只执行一次埋点； 点击form 里面input的点击的placeholder 判断input是否被上传过事件 没有就执行上传ga 然后改变状态
  // TODO 修改判断方式
  const handleFormClick = (event: React.MouseEvent) => {
    const target = event.target as HTMLInputElement | undefined;
    if (target) {
      if (target?.type === 'tel') {
        if (!formClickStatusRef.current.phone) {
          sendDataToGTM(prefixName`CLK_IPT@手机号`);
          report(`${pageName}_${REPORT_CLI_IPT_PHONE}_${l}`, {
            ...reportParams,
            event: REPORT_CLI_IPT_PHONE,
          });
          formClickStatusRef.current.phone = true;
        }
      } else if (target?.name === 'mail') {
        if (!formClickStatusRef.current.mail) {
          sendDataToGTM(prefixName`CLK_IPT@邮箱`);
          report(`${pageName}_${REPORT_CLI_IPT_MAIL}_${l}`, {
            ...reportParams,
            event: REPORT_CLI_IPT_MAIL,
          });
          formClickStatusRef.current.mail = true;
        }
      }
    }
  };

  const handleModalFinishFailed = (e: any) => {
    report(
      `${pageName}_${REPORT_FERM_WRONGFORM}_${l}`,
      {
        ...reportParams,
        event: REPORT_FERM_WRONGFORM,
        leadFail: {
          message: JSON.stringify(e?.errorFields[0]?.errors),
          mobile: JSON.stringify(e?.values?.phone),
          email: JSON.stringify(e?.values?.mail),
        },
      },
      true,
    );
  };

  return (
    <>
      <Head>
        <title>{t('title')}</title>
      </Head>
      <Nav className={styles.nav} />
      {/* <Banner /> */}
      <div
        className={classNames(styles.bannerContainer, {
          [styles.localeEnBanner]: locale === 'en',
        })}
      >
        <div className={styles.content}>
          <PC>
            <div className={styles.leftContainer}>
              <div className={styles.leftContainerImgL}>
                <Image
                  src={locale === 'en' ? bannerContentLEnImg : bannerContentLImg}
                  width={444}
                  height={617}
                  layout="responsive"
                  alt=""
                  placeholder="blur"
                />
              </div>
              <div className={styles.leftContainerImgR}>
                <Image
                  src={locale === 'en' ? bannerContentREnImg : bannerContentRImg}
                  width={482}
                  height={617}
                  layout="responsive"
                  alt=""
                  placeholder="blur"
                />
              </div>
            </div>
          </PC>
          <Mobile>
            <div className={styles.leftContainer}>
              <div className={styles.leftContainerMImg}>
                <Image
                  src={locale === 'en' ? bannerContentMEnImg : bannerContentMImg}
                  width={375}
                  height={347}
                  layout="responsive"
                  alt=""
                  placeholder="blur"
                />
              </div>
            </div>
          </Mobile>
          <div className={styles.formContainer}>
            <div className={styles.formBoxBg}>
              <div className={styles.formBox}>
                <div className={styles.formTitle} dangerouslySetInnerHTML={{ __html: t('banner-海外少儿在线课程') }} />
                <div className={styles.formContainerInner}>
                  <div>
                    <div
                      className={styles.formWelfareText}
                      dangerouslySetInnerHTML={{ __html: t('banner-立刻免费试听') }}
                    />
                    <ul className={styles.formWelfareBox}>
                      <li className={styles.formWelfareItem}>
                        <div className={styles.formWelfareImg}>
                          <Image
                            src="/images/chinese-math-class/banner-form-welfare-1.svg"
                            width={36}
                            height={36}
                            layout="responsive"
                            alt=""
                          />
                        </div>
                        <div className={styles.formWelfareItemText}>
                          <p>{t('banner-福利-1-部分1')}</p>
                          <p>{t('banner-福利-1-部分2')}</p>
                        </div>
                      </li>
                      <li className={styles.formWelfareItem}>
                        <div className={styles.formWelfareImg}>
                          <Image
                            src="/images/chinese-math-class/banner-form-welfare-2.svg"
                            width={36}
                            height={36}
                            layout="responsive"
                            alt=""
                          />
                        </div>
                        <div className={styles.formWelfareItemText}>
                          <p>{t('banner-福利-2-部分1')}</p>
                          <p>{t('banner-福利-2-部分2')}</p>
                        </div>
                      </li>
                      <li className={styles.formWelfareItem}>
                        <div className={styles.formWelfareImg}>
                          <Image
                            src="/images/chinese-math-class/banner-form-welfare-3.svg"
                            width={36}
                            height={36}
                            layout="responsive"
                            alt=""
                          />
                        </div>
                        <div className={styles.formWelfareItemText}>
                          <p>{t('banner-福利-3-部分1')}</p>
                          <p>{t('banner-福利-3-部分2')}</p>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <RCForm
                    form={form}
                    onClick={handleFormClick}
                    className={styles.form}
                    onFinish={handleFinish}
                    onFinishFailed={handleModalFinishFailed}
                  >
                    {isMobile ? (
                      <FormItem
                        className={styles.fixFormItem}
                        errClassName={styles.errClassName}
                        name="phone"
                        label=""
                        rules={[
                          {
                            validator(_, value) {
                              if (!value || !value[1]) {
                                return Promise.reject(new Error(t('表单-输入手机-提醒')));
                              }

                              if (!PHONE_REG.test(value[1])) {
                                return Promise.reject(new Error(t('表单-输入有效手机-提醒')));
                              }

                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <PhoneInputMobile placeholder={t('表单-请输入您的手机号')} language={locale as 'zh' | 'en'} />
                      </FormItem>
                    ) : (
                      <FormItem
                        className={styles.fixFormItem}
                        errClassName={styles.errClassName}
                        name="phone"
                        label=""
                        rules={[
                          {
                            validator(_, value) {
                              if (!value || !value[1]) {
                                return Promise.reject(new Error(t('表单-输入手机-提醒')));
                              }

                              if (!PHONE_REG.test(value[1])) {
                                return Promise.reject(new Error(t('表单-输入有效手机-提醒')));
                              }

                              return Promise.resolve();
                            },
                          },
                        ]}
                      >
                        <PhoneInput
                          countryCode={countryCode}
                          placeholder={t('表单-请输入您的手机号')}
                          inputClassName={styles.phoneInput}
                          countryCodeClassName={styles.countryCode}
                          // arrowClassName={styles.arrowClassName}
                        />
                      </FormItem>
                    )}

                    <FormItem
                      className={styles.fixFormItem}
                      errClassName={styles.errClassName}
                      name="mail"
                      label=""
                      rules={[
                        {
                          validator(_, value) {
                            // 不能全是空格 或者为空
                            const length = value?.split(' ')?.join('')?.length;
                            if (!length) {
                              return Promise.reject(new Error(t('表单-输入邮箱-提醒')));
                            }
                            if (!EMAIL_REG.test(value)) {
                              return Promise.reject(new Error(t('表单-输入有效邮箱-提醒')));
                            }
                            return Promise.resolve();
                          },
                        },
                      ]}
                    >
                      <Input
                        className={classNames(styles.fixInput, styles.input)}
                        placeholder={t('表单-请输入您的邮箱')}
                        maxLength={40}
                        onBlur={(e) => {
                          inputOnBlur(e, 'mail');
                        }}
                        name="mail"
                      />
                    </FormItem>
                    {locale === 'en' && (
                      <div className={styles.serviceLanguageBox}>
                        <div className={styles.serviceLanguageTitle}>Preferred Service Language </div>

                        <div className={styles.serviceSelectBox}>
                          <Select
                            placeholder=""
                            classNamePrefix="select"
                            className={styles.serviceSelect}
                            options={serviceLanguageOptions}
                            defaultValue={serviceLanguageOptions[1]}
                            onChange={(e) => {
                              setServeLanguage(e?.value);
                            }}
                            isSearchable={false}
                          />
                        </div>
                      </div>
                    )}
                    <Button type="submit" block className={styles.bannerBtn} disabled={btnDisabled}>
                      {t('按钮-点击免费领取')}
                    </Button>
                  </RCForm>
                </div>
              </div>
            </div>
          </div>
        </div>
        <PC>
          <div className={styles.bannerLeftImg}>
            <Image
              src="/images/chinese-math-class/banner-left.svg"
              width={230}
              height={742}
              layout="responsive"
              alt=""
            />
          </div>
        </PC>
        <PC>
          <div className={styles.bannerRightImg}>
            <Image
              src="/images/chinese-math-class/banner-right.svg"
              width={363}
              height={742}
              layout="responsive"
              alt=""
            />
          </div>
        </PC>
        <PC>
          <div className={styles.bannerLeftXLImg}>
            <Image
              src="/images/chinese-math-class/banner-left-xl.png"
              width={492}
              height={230}
              layout="responsive"
              alt=""
            />
          </div>
        </PC>
      </div>

      <div
        className={classNames(styles.container, {
          [styles.localeEn]: locale === 'en',
        })}
      >
        <div className={styles.buttonContainer}>
          <Button className={classNames(styles.button, styles.chineseBtn)} onClick={() => handleItemClick('chinese')}>
            {t('中文-按钮')}
          </Button>
          <Button className={classNames(styles.button, styles.mathBtn)} onClick={() => handleItemClick('math')}>
            {t('数学-按钮')}
          </Button>
        </div>
        {currentKey === 'chinese' ? <Chinese /> : <Math />}
        <div className={classNames(styles.footer, hideBtn && styles.footerIn)}>
          <PC>
            <div>
              <div className={styles.logoBox}>
                <div className={styles.monkeyContainer}>
                  <Image src={monkeyImg} alt="" placeholder="blur" width={147} height={152} layout="responsive" />
                </div>
                <div className={styles.sloganContainer}>
                  <div className={styles.logo}>
                    <Image src={sloganImg} alt="" width={136} height={45} layout="responsive" />
                  </div>
                  {/* <div className={styles.slogan}>{t('标语')}</div> */}
                </div>
              </div>
            </div>
          </PC>
          <div>
            <Button block className={styles.btn} onClick={handleToTop}>
              {t('立即免费试听')}
            </Button>
          </div>
        </div>
      </div>
      <Multilingual visible={successVisible} WXCodeUrl={WXCodeUrl} lang={locale} />
    </>
  );
};

export default withGTM(ChineseMathClass, GTM_CHINESEFORM_ARGUS);
